import { render, staticRenderFns } from "./index-ebook.vue?vue&type=template&id=361831cd&"
import script from "./index-ebook.vue?vue&type=script&lang=js&"
export * from "./index-ebook.vue?vue&type=script&lang=js&"
import style0 from "./index-ebook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports